import IconButton from 'apollo-react/components/IconButton';
import Tooltip from 'apollo-react/components/Tooltip';
import Question from 'apollo-react-icons/Question';
import React from 'react';

import { useFormSelector } from '../custom-hooks';
import {
  FORM_KEYS,
  FORM_MODEL_ATTRIBUTES,
} from '../form-designer/constants/form-manager.constants';
import {
  getFormKey,
  getPropByModel,
  getRootElements,
} from '../form-designer/selectors/form-manager.selectors';
import { equalityFn } from '../form-designer/utils/form-manager.utils';
import { getEnvVar } from '../utils/env';

const HelpLink = () => {
  const formKey = useFormSelector(getFormKey, { formKey: FORM_KEYS.STEP });
  const formHelpLinkMap = getEnvVar('FORM_HELPLINK_MAP') ?? {};
  const defaultHelpLinkUrl = formHelpLinkMap[formKey];

  const rootElement = useFormSelector(getRootElements, {}, equalityFn);
  const formHelpLinkText = useFormSelector(getPropByModel, {
    id: rootElement[0],
    prop: FORM_MODEL_ATTRIBUTES.HELP_LINK_TEXT,
    formKey: FORM_KEYS.STEP,
  });

  const formHelpLinkUrl = useFormSelector(getPropByModel, {
    id: rootElement[0],
    prop: FORM_MODEL_ATTRIBUTES.HELP_LINK_URL,
    formKey: FORM_KEYS.STEP,
  });

  const adminAppUrl = getEnvVar('REACT_APP_ADMIN_APP_URL');

  const helpUrlWithDomain = `${adminAppUrl}/Help/${formHelpLinkUrl || defaultHelpLinkUrl}`;

  const onClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
    window.open(helpUrlWithDomain, '_blank');
  };

  if ((!formHelpLinkText || !formHelpLinkUrl) && !defaultHelpLinkUrl) {
    return null;
  }

  return (
    <Tooltip title={formHelpLinkText} placement="bottom">
      <IconButton aria-label="Open help link in a new window" onClick={onClick}>
        <Question color="primary" size="small" />
      </IconButton>
    </Tooltip>
  );
};

export default HelpLink;
